export default "__VITE_ASSET__gKKoyD2n__"